import { memo, useEffect, useState } from "react";
import * as pdf from "pdfobject";
import "../components.css";
import "./PdfReader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import { usePdfReaderStore } from "@mirage/store/store";

export interface PdfReaderProps {
    pdfUrl?: string;
    containerId?: string;
    title?: string;
}
export const PopUpPdfReader = memo((props: PdfReaderProps) => {
    const readerAtomState = usePdfReaderStore((s) => s.pdfReader);
    const resetPdfReader = usePdfReaderStore((s) => s.resetPdfReader);
    const [visible, setVisible] = useState(false);
    const locationHash = useLocation().hash;
    const hashMatch = locationHash === "#readDocument";
    const id = props.containerId || "pdfReader";
    let url = props.pdfUrl || readerAtomState.pdfUrl;
    if (url.length > 2000) {
        const base64 = url.split(",")[1];
        const array = new Uint8Array(
            atob(base64)
                .split("")
                .map((c) => c.charCodeAt(0))
        );
        const blob = new Blob([array], { type: "application/pdf" });
        url = URL.createObjectURL(blob);
    }

    useEffect(() => {
        if (!url || !hashMatch) {
            setVisible(false);
            URL.revokeObjectURL(url);
            document.body.classList.remove("noscroll");
            return;
        }
        pdf.embed(url, "#" + id, {
            fallbackLink: "<p>Pdf is corrupted or not accessible</p>",
        });
        document.body.classList.add("noscroll");
        setVisible(true);
    }, [locationHash, id, hashMatch, url]);

    const onCloseClicked = () => {
        resetPdfReader();
        history.back();
    };
    const className = visible ? "" : "container--hidden";
    const fullWindowModifier = "popupContainer--fullWindow";
    return (
        <div className={`popupContainer ${fullWindowModifier} ${className}`}>
            <div className="container__toolBar container__toolBar--rightAligned">
                <Tooltip title="Close">
                    <FontAwesomeIcon className="container__pointerIcon" icon={faXmark} onClick={onCloseClicked} />
                </Tooltip>
            </div>
            <div id={id} className="container--fullHeight"></div>
        </div>
    );
});
